import React from 'react';
import { connect } from 'react-redux';
import { Segment, Header, Grid } from 'semantic-ui-react';
import { groupBy as _groupBy, keys as _keys, isEmpty as _isEmpty, keyBy as _keyBy } from 'lodash';
import './OpenRequestsContainer.less';
import ProjectsBids from '../../components/ProjectsBids/ProjectsBids'
import { setActiveMenuItem } from '../../store/actions/actions';
import { setDisableSellerRedirection } from "../../store/actions/seller"
import { getServiceRequestBidsByMarket } from '../../services/Project';
import { getCategoryService } from '../../services/Services';

class OpenRequestsByMarketContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryServices: []
        }
    }

    async componentDidMount() {
        this.props.setDisableSellerRedirection(true);
        const res = await getCategoryService(this.props.match.params.category);
        if (res && res.data && res.data.length) {

            this.setState({ categoryServices: res.data || [] });
        } else {
            this.props.history.push('/business/signup')
        }
    }

    handlePinToggle = async (service, servicePinID) => {
        const { categoryServices } = this.state;
        _.each(categoryServices, ss => ss.serviceID === service.serviceID ? ss.servicePinID = servicePinID : '');
        this.setState({ categoryServices });
    }

    render() {
        const { categoryServices } = this.state;
        const visitTime = this.props.location.state && this.props.location.state.visitTime;

        return (
            <div className="LosingBidsContainer animated fadeInRight">
                <Segment.Group>
                    <Segment size="massive" className="no-radius">
                        <Header as="h1">
                            <Header.Content>
                                Active Jobs Needing Quotes
                            </Header.Content>
                        </Header>
                    </Segment>

                </Segment.Group>
                <Grid celled>
                    <Grid.Row>
                        <Grid.Column>
                            {categoryServices.map((service, i) => {
                                return (
                                    <ProjectsBids isUnAuthorized 
                                        hideDetails={true} 
                                        service={service} 
                                        getRequests={() => getServiceRequestBidsByMarket(service.serviceID, this.props.match.params.market)}
                                        onTogglePin={(servicePinID) => this.handlePinToggle(service, servicePinID)}
                                        key={`service${i}`} history={this.props.history}
                                        visitTime={visitTime}
                                        showDistanceWidget={true}
                                    />
                                )
                            })}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = {
    setActiveMenuItem,
    setDisableSellerRedirection
}

export default connect(null, mapDispatchToProps)(OpenRequestsByMarketContainer);